import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../service/auth-service';
import { CommonModule } from '@angular/common';
import { TextInputComponent } from '../../../shared/components/text-input/text-input.component';
import { checkPasswordMismatch, passwordValidator } from '../../../shared/validators/common.validators';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TextInputComponent],
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  isLoading = false;
  token: string = '';
  isPasswordVisible = false;
  isConfirmPasswordVisible = false;
  passwordMismatch:boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.resetPasswordForm = this.fb.group({
    password: new FormControl('', passwordValidator),
    confirmPassword: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {
    this.token = this.route.snapshot.queryParams['code'];
    if (!this.token) {
    //  this.toastr.error('Invalid reset token');
      this.router.navigate(['/auth/forgot-password']);
    }
  }

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  toggleConfirmPasswordVisibility() {
    this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
  }

  onPasswordInput() {
    this.passwordMismatch = checkPasswordMismatch(this.resetPasswordForm);
  }

  resetPassword() {
    if (this.resetPasswordForm.valid) {
    if (
      this.resetPasswordForm.value.password !== this.resetPasswordForm.value.confirmPassword
    ) {
      this.passwordMismatch = true;
      return;
    }

    this.isLoading = true;
    const { password, confirmPassword } = this.resetPasswordForm.value;

    this.authService.resetPassword(this.token, password, confirmPassword).pipe(
      finalize(() => {
        this.isLoading = false;
      })
    ).subscribe({
      next: () => {
        this.toastr.success('Password has been reset successfully');
        this.router.navigate(['/auth/login']);
      },
       error: (error) => {
        const message = [401, 403, 400, 500].includes(error.status)
          ? error?.error?.message
          : error.message;
        const errorMessage =
          message || 'Failed to reset password. Please try again.';
          this.toastr.error(errorMessage, 'Error');
      },
    });
  }
  }

  getControl(fieldName: string): FormControl {
    return (this.resetPasswordForm.get(fieldName) as FormControl) || new FormControl();
  }


  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control instanceof FormControl) {
        control.markAsTouched();
        control.markAsDirty();
      }
    });
  }

get passwordErrors() {
    return this.resetPasswordForm.get('password')?.errors || {};
  }

get passwordsMismatch() {
    return checkPasswordMismatch(this.resetPasswordForm);
  }


}
